// ManageApplications.jsx
import React, { useState, useEffect, useCallback } from "react";

import {
  getInternshipApplications,
  getInternships,
  updateApplicationDecision,
  downloadCV,
  isFormActive,
  updateConfig,
  updateApplication,
} from "../../services/api";

// Icônes SVG simples
const CheckCircle = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const XCircle = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const Clock = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const AlertCircle = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const Download = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
    />
  </svg>
);

const Edit = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
  </svg>
);

const FileSpreadsheet = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    />
  </svg>
);

const Eye = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    />
  </svg>
);

const Filter = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
    />
  </svg>
);

const Search = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);

const Calendar = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
    />
  </svg>
);

const User = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    />
  </svg>
);

const Mail = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);

const Phone = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
    />
  </svg>
);

const Building = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
    />
  </svg>
);

const Settings = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    />
  </svg>
);

const ManageApplications = ({ token }) => {
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [internships, setInternships] = useState([]);
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Vue active (applications ou configuration)
  const [activeView, setActiveView] = useState("applications");

  // Filtres
  const [searchTerm, setSearchTerm] = useState("");
  const [filterDecision, setFilterDecision] = useState("Tous");
  const [filterType, setFilterType] = useState("Tous");

  // Modal de détails
  const [selectedApp, setSelectedApp] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Modal d'édition
  const [editingApp, setEditingApp] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editForm, setEditForm] = useState({
    prenom: "",
    nom: "",
    email: "",
    tel: "",
    etablissement: "",
    diplome: "",
    specialite: "",
    premierChoix: "",
    deuxiemeChoix: "",
    annee: new Date().getFullYear(),
  });

  // Menu d'export
  const [showExportMenu, setShowExportMenu] = useState(false);

  // Formulaire de configuration
  const [configForm, setConfigForm] = useState({
    year: new Date().getFullYear(),
    startDate: "",
    endDate: "",
  });

  const loadInternships = useCallback(async () => {
    try {
      const data = await getInternships();
      setInternships(data.data);
    } catch (err) {
      console.error("Erreur lors du chargement des stages:", err);
    }
  }, []);

  const loadConfig = useCallback(async () => {
    try {
      const [configRes] = await Promise.all([isFormActive()]);
      setConfig(configRes.data.config);
      setConfigForm({
        year: configRes.data.config.year,
        startDate: new Date(configRes.data.config.startDate)
          .toISOString()
          .split("T")[0],
        endDate: new Date(configRes.data.config.endDate)
          .toISOString()
          .split("T")[0],
      });
    } catch (error) {
      console.error("Erreur:", error);
    }
  }, []);

  const loadApplications = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const response = await getInternshipApplications();
      const data = response.data;

      // Filtrer par année configurée
      const filteredByYear = config
        ? data.filter((app) => app.annee === config.year)
        : data;

      setApplications(filteredByYear);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [config]);

  const applyFilters = useCallback(() => {
    let filtered = [...applications];

    // Filtre par recherche (nom, email, établissement)
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (app) =>
          app.prenom.toLowerCase().includes(term) ||
          app.nom.toLowerCase().includes(term) ||
          app.email.toLowerCase().includes(term) ||
          app.etablissement.toLowerCase().includes(term),
      );
    }

    // Filtre par décision
    if (filterDecision !== "Tous") {
      filtered = filtered.filter((app) => app.decision === filterDecision);
    }

    // Filtre par type de stage (premier choix)
    if (filterType !== "Tous") {
      filtered = filtered.filter(
        (app) => app.premierChoix?.type === filterType,
      );
    }

    setFilteredApplications(filtered);
  }, [applications, searchTerm, filterDecision, filterType]);

  useEffect(() => {
    loadConfig();
    loadInternships();
  }, [loadConfig, loadInternships]);

  useEffect(() => {
    if (config) {
      loadApplications();
    }
  }, [config, loadApplications]);

  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  const saveConfig = async () => {
    try {
      setLoading(true);
      setError("");
      setSuccess("");

      // Validation des champs
      if (!configForm.year || !configForm.startDate || !configForm.endDate) {
        setError("Veuillez remplir tous les champs");
        setLoading(false);
        return;
      }

      // Validation des dates
      const startDate = new Date(configForm.startDate);
      const endDate = new Date(configForm.endDate);

      if (endDate <= startDate) {
        setError("La date de fin doit être postérieure à la date de début");
        setLoading(false);
        return;
      }
      await updateConfig(configForm);

      setSuccess(
        "Configuration sauvegardée avec succès ! Le formulaire sera accessible pendant la période définie.",
      );
      setTimeout(() => setSuccess(""), 5000);

      // Recharger la configuration
      await loadConfig();

      // Recharger les applications si on est dans cette vue
      if (activeView === "applications") {
        await loadApplications();
      }
    } catch (err) {
      console.error("Erreur lors de la sauvegarde:", err);
      setError(
        err.message || "Erreur lors de la sauvegarde de la configuration",
      );
    } finally {
      setLoading(false);
    }
  };

  const updateDecision = async (appId, decision) => {
    try {
      setLoading(true);
      setError("");

      await updateApplicationDecision(appId, { decision });

      setSuccess(`Décision mise à jour : ${decision}`);
      setTimeout(() => setSuccess(""), 3000);

      loadApplications();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const getDecisionBadge = (decision) => {
    const styles = {
      Interview: "bg-blue-100 text-blue-800 border-blue-200",
      Accepté: "bg-green-100 text-green-800 border-green-200",
      Refusé: "bg-red-100 text-red-800 border-red-200",
      "En attente": "bg-yellow-100 text-yellow-800 border-yellow-200",
    };
    return styles[decision] || styles["En attente"];
  };

  const getDecisionIcon = (decision) => {
    switch (decision) {
      case "Interview":
        return <CheckCircle className="w-4 h-4" />;
      case "Accepté":
        return <CheckCircle className="w-4 h-4" />;
      case "Refusé":
        return <XCircle className="w-4 h-4" />;
      default:
        return <Clock className="w-4 h-4" />;
    }
  };

  const getStats = () => {
    return {
      total: applications.length,
      enAttente: applications.filter((app) => app.decision === "En attente")
        .length,
      interview: applications.filter((app) => app.decision === "Interview")
        .length,
      accepte: applications.filter((app) => app.decision === "Accepté").length,
      refuse: applications.filter((app) => app.decision === "Refusé").length,
    };
  };

  const stats = getStats();

  const openModal = (app) => {
    setSelectedApp(app);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedApp(null);
  };

  const openEditModal = (app) => {
    setEditingApp(app);
    setEditForm({
      prenom: app.prenom,
      nom: app.nom,
      email: app.email,
      tel: app.tel,
      etablissement: app.etablissement,
      diplome: app.diplome,
      specialite: app.specialite,
      premierChoix: app.premierChoix?._id || "",
      deuxiemeChoix: app.deuxiemeChoix?._id || "",
      annee: app.annee,
    });
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditingApp(null);
  };

  const handleUpdateApplication = async () => {
    try {
      setLoading(true);
      setError("");

      // Validation
      if (
        !editForm.prenom ||
        !editForm.nom ||
        !editForm.email ||
        !editForm.tel ||
        !editForm.etablissement ||
        !editForm.diplome ||
        !editForm.specialite ||
        !editForm.premierChoix ||
        !editForm.deuxiemeChoix
      ) {
        setError("Veuillez remplir tous les champs obligatoires");
        setLoading(false);
        return;
      }

      if (editForm.premierChoix === editForm.deuxiemeChoix) {
        setError("Les deux choix doivent être différents");
        setLoading(false);
        return;
      }

      await updateApplication(editingApp._id, editForm, token);

      setSuccess("Candidature mise à jour avec succès");
      setTimeout(() => setSuccess(""), 3000);

      closeEditModal();
      loadApplications();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const exportToExcel = () => {
    try {
      // Préparer les données pour l'export
      const dataToExport = filteredApplications.map((app, index) => ({
        "N°": index + 1,
        Prénom: app.prenom,
        Nom: app.nom,
        Email: app.email,
        Téléphone: app.tel,
        Établissement: app.etablissement,
        Diplôme: app.diplome,
        Spécialité: app.specialite,
        Année: app.annee,
        "Premier Choix": app.premierChoix?.title || "N/A",
        "Type Premier Choix": app.premierChoix?.type || "N/A",
        "Référence Premier Choix": app.premierChoix?.ref || "N/A",
        "Deuxième Choix": app.deuxiemeChoix?.title || "N/A",
        "Type Deuxième Choix": app.deuxiemeChoix?.type || "N/A",
        "Référence Deuxième Choix": app.deuxiemeChoix?.ref || "N/A",
        Décision: app.decision,
        "Date de soumission": new Date(app.submittedAt).toLocaleDateString(
          "fr-FR",
        ),
      }));

      if (dataToExport.length === 0) {
        alert("Aucune candidature à exporter");
        return;
      }

      // Créer le fichier CSV
      const headers = Object.keys(dataToExport[0]);
      const csvContent = [
        // En-têtes
        headers.join(","),
        // Données
        ...dataToExport.map((row) =>
          headers
            .map((header) => {
              const value = row[header];
              // Échapper les virgules et guillemets
              if (
                typeof value === "string" &&
                (value.includes(",") ||
                  value.includes('"') ||
                  value.includes("\n"))
              ) {
                return `"${value.replace(/"/g, '""')}"`;
              }
              return value;
            })
            .join(","),
        ),
      ].join("\n");

      // Ajouter le BOM UTF-8 pour Excel
      const BOM = "\uFEFF";
      const blob = new Blob([BOM + csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      // Télécharger le fichier
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `candidatures_${config?.year || new Date().getFullYear()}_${
          new Date().toISOString().split("T")[0]
        }.csv`,
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setSuccess(
        `✅ Export réussi : ${dataToExport.length} candidatures exportées`,
      );
      setTimeout(() => setSuccess(""), 3000);
    } catch (error) {
      console.error("Erreur lors de l'export:", error);
      setError("Erreur lors de l'export des données");
    }
  };

  const exportWithStats = () => {
    try {
      // Calculer les statistiques
      const stats = {
        total: filteredApplications.length,
        enAttente: filteredApplications.filter(
          (app) => app.decision === "En attente",
        ).length,
        interview: filteredApplications.filter(
          (app) => app.decision === "Interview",
        ).length,
        accepte: filteredApplications.filter(
          (app) => app.decision === "Accepté",
        ).length,
        refuse: filteredApplications.filter((app) => app.decision === "Refusé")
          .length,
      };

      // Préparer les données avec statistiques
      const dataToExport = [
        [
          "RAPPORT DES CANDIDATURES - ANNÉE " +
            (config?.year || new Date().getFullYear()),
        ],
        ["Généré le", new Date().toLocaleString("fr-FR")],
        [],
        ["STATISTIQUES"],
        ["Total", stats.total],
        ["En attente", stats.enAttente],
        ["Interview", stats.interview],
        ["Acceptées", stats.accepte],
        ["Refusées", stats.refuse],
        [],
        ["LISTE DES CANDIDATURES"],
        [
          "N°",
          "Prénom",
          "Nom",
          "Email",
          "Téléphone",
          "Établissement",
          "Diplôme",
          "Spécialité",
          "Année",
          "Premier Choix",
          "Type",
          "Deuxième Choix",
          "Décision",
          "Date",
        ],
        ...filteredApplications.map((app, index) => [
          index + 1,
          app.prenom,
          app.nom,
          app.email,
          app.tel,
          app.etablissement,
          app.diplome,
          app.specialite,
          app.annee,
          app.premierChoix?.title || "N/A",
          app.premierChoix?.type || "N/A",
          app.deuxiemeChoix?.title || "N/A",
          app.decision,
          new Date(app.submittedAt).toLocaleDateString("fr-FR"),
        ]),
      ];

      // Créer le CSV
      const csvContent = dataToExport
        .map((row) =>
          row
            .map((cell) => {
              if (
                typeof cell === "string" &&
                (cell.includes(",") ||
                  cell.includes('"') ||
                  cell.includes("\n"))
              ) {
                return `"${cell.replace(/"/g, '""')}"`;
              }
              return cell;
            })
            .join(","),
        )
        .join("\n");

      const BOM = "\uFEFF";
      const blob = new Blob([BOM + csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `rapport_candidatures_${config?.year || new Date().getFullYear()}_${
          new Date().toISOString().split("T")[0]
        }.csv`,
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setSuccess(`✅ Rapport exporté avec statistiques`);
      setTimeout(() => setSuccess(""), 3000);
      setShowExportMenu(false);
    } catch (error) {
      console.error("Erreur lors de l'export:", error);
      setError("Erreur lors de l'export des données");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header avec onglets */}
        <div className="bg-white rounded-lg shadow-md mb-6">
          <div className="flex border-b border-gray-200">
            <button
              onClick={() => setActiveView("applications")}
              className={`flex-1 px-6 py-4 text-center font-medium transition-colors ${
                activeView === "applications"
                  ? "text-indigo-600 border-b-2 border-indigo-600 bg-indigo-50"
                  : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
              }`}
            >
              <User className="w-5 h-5 inline mr-2" />
              Candidatures ({filteredApplications.length})
            </button>
            <button
              onClick={() => setActiveView("config")}
              className={`flex-1 px-6 py-4 text-center font-medium transition-colors ${
                activeView === "config"
                  ? "text-indigo-600 border-b-2 border-indigo-600 bg-indigo-50"
                  : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
              }`}
            >
              <Settings className="w-5 h-5 inline mr-2" />
              Configuration
            </button>
          </div>
        </div>

        {/* Statistiques */}
      </div>

      {/* Messages */}
      {error && (
        <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 flex items-start gap-3">
          <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5" />
          <span>{error}</span>
        </div>
      )}

      {success && (
        <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg text-green-700 flex items-start gap-3">
          <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" />
          <span>{success}</span>
        </div>
      )}

      {/* Vue Configuration */}
      {activeView === "config" && (
        <div className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">
            Configuration du Formulaire
          </h2>

          <div className="space-y-6 max-w-2xl">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Année du programme
              </label>
              <input
                type="number"
                value={configForm.year}
                onChange={(e) =>
                  setConfigForm({
                    ...configForm,
                    year: parseInt(e.target.value),
                  })
                }
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                placeholder="2025"
              />
              <p className="text-xs text-gray-500 mt-1">
                Les candidatures de cette année seront affichées dans l'onglet
                "Candidatures"
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Date de début d'ouverture du formulaire
              </label>
              <input
                type="date"
                value={configForm.startDate}
                onChange={(e) =>
                  setConfigForm({ ...configForm, startDate: e.target.value })
                }
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Date de fin de fermeture du formulaire
              </label>
              <input
                type="date"
                value={configForm.endDate}
                onChange={(e) =>
                  setConfigForm({ ...configForm, endDate: e.target.value })
                }
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
            </div>

            {/* Statut actuel */}
            {config && (
              <div className="pt-4">
                <div
                  className={`p-4 rounded-lg border ${
                    new Date() >= new Date(config.startDate) &&
                    new Date() <= new Date(config.endDate)
                      ? "bg-green-50 border-green-200"
                      : "bg-red-50 border-red-200"
                  }`}
                >
                  <div className="flex items-center gap-2 mb-2">
                    <Calendar className="w-5 h-5" />
                    <p
                      className={`font-medium ${
                        new Date() >= new Date(config.startDate) &&
                        new Date() <= new Date(config.endDate)
                          ? "text-green-800"
                          : "text-red-800"
                      }`}
                    >
                      Statut actuel:{" "}
                      {new Date() >= new Date(config.startDate) &&
                      new Date() <= new Date(config.endDate)
                        ? "✓ Formulaire actif"
                        : "✗ Formulaire inactif"}
                    </p>
                  </div>
                  <p className="text-sm text-gray-600 ml-7">
                    Période configurée :{" "}
                    {new Date(config.startDate).toLocaleDateString("fr-FR")} -{" "}
                    {new Date(config.endDate).toLocaleDateString("fr-FR")}
                  </p>
                  <p className="text-sm text-gray-600 ml-7 mt-1">
                    Année actuelle : {config.year}
                  </p>
                </div>
              </div>
            )}

            {/* Bouton de sauvegarde */}
            <div className="pt-4">
              <button
                onClick={saveConfig}
                disabled={
                  loading ||
                  !configForm.year ||
                  !configForm.startDate ||
                  !configForm.endDate
                }
                className="w-full bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {loading ? (
                  <span className="flex items-center justify-center gap-2">
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    Enregistrement en cours...
                  </span>
                ) : (
                  "Enregistrer la configuration"
                )}
              </button>
              {(!configForm.year ||
                !configForm.startDate ||
                !configForm.endDate) && (
                <p className="text-xs text-red-500 mt-2 text-center">
                  Veuillez remplir tous les champs avant d'enregistrer
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Vue Applications */}
      {activeView === "applications" && (
        <>
          {/* Header statistiques */}
          <div className="bg-white rounded-lg shadow-md p-6 mb-6">
            <div className="flex items-center justify-between mb-4">
              <div>
                <h2 className="text-2xl font-bold text-gray-800">
                  Gestion des Candidatures
                </h2>
                <p className="text-gray-600 mt-1">
                  Année {config?.year || new Date().getFullYear()} - Total:{" "}
                  {filteredApplications.length} candidatures
                </p>
              </div>

              <div className="relative export-menu-container">
                <button
                  onClick={() => setShowExportMenu(!showExportMenu)}
                  disabled={filteredApplications.length === 0}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 transition-colors"
                  title="Exporter"
                >
                  <FileSpreadsheet className="w-5 h-5" />
                  Exporter
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>

                {/* Menu d'export */}
                {showExportMenu && (
                  <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 z-10">
                    <div className="py-2">
                      <button
                        onClick={() => {
                          exportToExcel();
                          setShowExportMenu(false);
                        }}
                        className="w-full text-left px-4 py-3 hover:bg-gray-50 flex items-center gap-3 transition-colors"
                      >
                        <FileSpreadsheet className="w-5 h-5 text-green-600" />
                        <div>
                          <p className="text-sm font-medium text-gray-900">
                            Export simple
                          </p>
                          <p className="text-xs text-gray-500">
                            Liste des candidatures (CSV)
                          </p>
                        </div>
                      </button>

                      <button
                        onClick={exportWithStats}
                        className="w-full text-left px-4 py-3 hover:bg-gray-50 flex items-center gap-3 transition-colors border-t border-gray-100"
                      >
                        <FileSpreadsheet className="w-5 h-5 text-indigo-600" />
                        <div>
                          <p className="text-sm font-medium text-gray-900">
                            Export avec stats
                          </p>
                          <p className="text-xs text-gray-500">
                            Rapport détaillé (CSV)
                          </p>
                        </div>
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <button
                onClick={loadApplications}
                disabled={loading}
                className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50"
              >
                {loading ? "Chargement..." : "Actualiser"}
              </button>
            </div>

            {/* Statistiques */}
            <div className="grid grid-cols-4 gap-4 mt-6">
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-sm text-gray-600 mb-1">Total</p>
                <p className="text-2xl font-bold text-gray-800">
                  {stats.total}
                </p>
              </div>
              <div className="bg-yellow-50 p-4 rounded-lg">
                <p className="text-sm text-yellow-700 mb-1">En attente</p>
                <p className="text-2xl font-bold text-yellow-800">
                  {stats.enAttente}
                </p>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg">
                <p className="text-sm text-blue-700 mb-1">Interview</p>
                <p className="text-2xl font-bold text-blue-800">
                  {stats.interview}
                </p>
              </div>
              <div className="bg-green-50 p-4 rounded-lg">
                <p className="text-sm text-green-700 mb-1">Acceptées</p>
                <p className="text-2xl font-bold text-green-800">
                  {stats.accepte}
                </p>
              </div>
              <div className="bg-red-50 p-4 rounded-lg">
                <p className="text-sm text-red-700 mb-1">Refusées</p>
                <p className="text-2xl font-bold text-red-800">
                  {stats.refuse}
                </p>
              </div>
            </div>
          </div>

          {/* Filtres */}
          <div className="bg-white rounded-lg shadow-md p-6 mb-6">
            <div className="grid md:grid-cols-3 gap-4">
              {/* Recherche */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <Search className="w-4 h-4 inline mr-2" />
                  Rechercher
                </label>
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Nom, email, établissement..."
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                />
              </div>

              {/* Filtre décision */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <Filter className="w-4 h-4 inline mr-2" />
                  Statut
                </label>
                <select
                  value={filterDecision}
                  onChange={(e) => setFilterDecision(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                >
                  <option value="Tous">Tous les statuts</option>
                  <option value="En attente">En attente</option>
                  <option value="Accepté">Accepté</option>
                  <option value="Interview">Interview</option>
                  <option value="Refusé">Refusé</option>
                </select>
              </div>

              {/* Filtre type */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <Filter className="w-4 h-4 inline mr-2" />
                  Type de stage
                </label>
                <select
                  value={filterType}
                  onChange={(e) => setFilterType(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                >
                  <option value="Tous">Tous les types</option>
                  <option value="PFE">PFE</option>
                  <option value="Stage Ingénieur">Stage Ingénieur</option>
                  <option value="Stage Technicien">Stage Technicien</option>
                </select>
              </div>
            </div>
          </div>

          {/* Table des candidatures */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Candidat
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Contact
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Établissement
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Premier Choix
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Deuxième Choix
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Statut
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Date
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {filteredApplications.map((app) => (
                    <tr
                      key={app._id}
                      className="hover:bg-gray-50 transition-colors"
                    >
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2">
                          <User className="w-4 h-4 text-gray-400" />
                          <div>
                            <p className="text-sm font-medium text-gray-900">
                              {app.prenom} {app.nom}
                            </p>
                            <p className="text-xs text-gray-500">
                              {app.diplome} - {app.specialite}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-sm">
                          <div className="flex items-center gap-2 text-gray-600 mb-1">
                            <Mail className="w-3 h-3" />
                            <a
                              href={`mailto:${app.email}`}
                              className="hover:text-indigo-600"
                            >
                              {app.email}
                            </a>
                          </div>
                          <div className="flex items-center gap-2 text-gray-600">
                            <Phone className="w-3 h-3" />
                            <span>{app.tel}</span>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2">
                          <Building className="w-4 h-4 text-gray-400" />
                          <span className="text-sm text-gray-900">
                            {app.etablissement}
                          </span>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-sm">
                          <p className="font-medium text-gray-900">
                            {app.premierChoix?.title}
                          </p>
                          <span className="inline-block mt-1 px-2 py-1 text-xs rounded-full bg-indigo-100 text-indigo-800">
                            {app.premierChoix?.ref}
                          </span>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-sm">
                          <p className="font-medium text-gray-900">
                            {app.deuxiemeChoix?.title}
                          </p>
                          <span className="inline-block mt-1 px-2 py-1 text-xs rounded-full bg-indigo-100 text-indigo-800">
                            {app.deuxiemeChoix?.ref}
                          </span>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span
                          className={`inline-flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-full border ${getDecisionBadge(
                            app.decision,
                          )}`}
                        >
                          {getDecisionIcon(app.decision)}
                          {app.decision}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <Calendar className="w-4 h-4" />
                          {new Date(app.submittedAt).toLocaleDateString(
                            "fr-FR",
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex gap-2">
                          <button
                            onClick={() => openModal(app)}
                            className="text-indigo-600 hover:text-indigo-800"
                            title="Voir détails"
                          >
                            <Eye className="w-5 h-5" />
                          </button>
                          <button
                            onClick={() => openEditModal(app)}
                            className="text-blue-600 hover:text-blue-800"
                            title="Modifier"
                          >
                            <Edit className="w-5 h-5" />
                          </button>
                          <button
                            onClick={() => updateDecision(app._id, "Accepté")}
                            disabled={loading || app.decision === "Accepté"}
                            className="text-green-600 hover:text-green-800 disabled:opacity-30"
                            title="Accepter"
                          >
                            <CheckCircle className="w-5 h-5" />
                          </button>
                          <button
                            onClick={() => updateDecision(app._id, "Interview")}
                            disabled={loading || app.decision === "Interview"}
                            className="text-blue-600 hover:text-blue-800 disabled:opacity-30"
                            title="Interview"
                          >
                            <CheckCircle className="w-5 h-5" />
                          </button>
                          <button
                            onClick={() => updateDecision(app._id, "Refusé")}
                            disabled={loading || app.decision === "Refusé"}
                            className="text-red-600 hover:text-red-800 disabled:opacity-30"
                            title="Refuser"
                          >
                            <XCircle className="w-5 h-5" />
                          </button>
                          <button
                            onClick={() =>
                              updateDecision(app._id, "En attente")
                            }
                            disabled={loading || app.decision === "En attente"}
                            className="text-yellow-600 hover:text-yellow-800 disabled:opacity-30"
                            title="Mettre en attente"
                          >
                            <Clock className="w-5 h-5" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="text-center py-12 text-gray-500">
              <AlertCircle className="w-12 h-12 mx-auto mb-4 text-gray-400" />
              <p>Aucune candidature trouvée</p>
            </div>
          </div>
        </>
      )}

      {/* Modal de détails */}
      {showModal && selectedApp && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold text-gray-800">
                  Détails de la candidature
                </h2>
                <button
                  onClick={closeModal}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <XCircle className="w-6 h-6" />
                </button>
              </div>
            </div>

            <div className="p-6 space-y-6">
              {/* Informations personnelles */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Informations personnelles
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm text-gray-600">Prénom</p>
                    <p className="font-medium">{selectedApp.prenom}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">Nom</p>
                    <p className="font-medium">{selectedApp.nom}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">Email</p>
                    <p className="font-medium">{selectedApp.email}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">Téléphone</p>
                    <p className="font-medium">{selectedApp.tel}</p>
                  </div>
                </div>
              </div>

              {/* Formation */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Formation
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm text-gray-600">Établissement</p>
                    <p className="font-medium">{selectedApp.etablissement}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">Diplôme</p>
                    <p className="font-medium">{selectedApp.diplome}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">Spécialité</p>
                    <p className="font-medium">{selectedApp.specialite}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">Année</p>
                    <p className="font-medium">{selectedApp.annee}</p>
                  </div>
                </div>
              </div>

              {/* Choix de stages */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Choix de stages
                </h3>
                <div className="space-y-3">
                  <div className="p-4 bg-indigo-50 rounded-lg">
                    <p className="text-sm text-indigo-600 font-medium mb-1">
                      Premier choix
                    </p>
                    <p className="font-semibold">
                      {selectedApp.premierChoix?.title}
                    </p>
                    <p className="text-sm text-gray-600 mt-1">
                      Réf: {selectedApp.premierChoix?.ref} - Type:{" "}
                      {selectedApp.premierChoix?.type}
                    </p>
                  </div>
                  <div className="p-4 bg-gray-50 rounded-lg">
                    <p className="text-sm text-gray-600 font-medium mb-1">
                      Deuxième choix
                    </p>
                    <p className="font-semibold">
                      {selectedApp.deuxiemeChoix?.title}
                    </p>
                    <p className="text-sm text-gray-600 mt-1">
                      Réf: {selectedApp.deuxiemeChoix?.ref} - Type:{" "}
                      {selectedApp.deuxiemeChoix?.type}
                    </p>
                  </div>
                </div>
              </div>

              {/* Statut et CV */}
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <p className="text-sm text-gray-600 mb-1">Statut actuel</p>
                  <span
                    className={`inline-flex items-center gap-1 px-3 py-1 text-sm font-medium rounded-full border ${getDecisionBadge(
                      selectedApp.decision,
                    )}`}
                  >
                    {getDecisionIcon(selectedApp.decision)}
                    {selectedApp.decision}
                  </span>
                </div>
                <a
                  href={downloadCV(selectedApp.cvPath)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
                >
                  <Download className="w-4 h-4" />
                  Télécharger CV
                </a>
              </div>

              {/* Actions */}
              <div className="flex gap-3 pt-4 border-t">
                <button
                  onClick={() => {
                    updateDecision(selectedApp._id, "Accepté");
                    closeModal();
                  }}
                  disabled={selectedApp.decision === "Accepté"}
                  className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  <CheckCircle className="w-4 h-4" />
                  Accepter
                </button>
                <button
                  onClick={() => {
                    updateDecision(selectedApp._id, "Interview");
                    closeModal();
                  }}
                  disabled={selectedApp.decision === "Interview"}
                  className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  <CheckCircle className="w-4 h-4" />
                  Interview
                </button>
                <button
                  onClick={() => {
                    updateDecision(selectedApp._id, "Refusé");
                    closeModal();
                  }}
                  disabled={selectedApp.decision === "Refusé"}
                  className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  <XCircle className="w-4 h-4" />
                  Refuser
                </button>
                <button
                  onClick={() => {
                    updateDecision(selectedApp._id, "En attente");
                    closeModal();
                  }}
                  disabled={selectedApp.decision === "En attente"}
                  className="flex-1 px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  <Clock className="w-4 h-4" />
                  En attente
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal d'édition */}
      {showEditModal && editingApp && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold text-gray-800">
                  Modifier la candidature
                </h2>
                <button
                  onClick={closeEditModal}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <XCircle className="w-6 h-6" />
                </button>
              </div>
            </div>

            <div className="p-6 space-y-6">
              {/* Informations personnelles */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Informations personnelles
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Prénom *
                    </label>
                    <input
                      type="text"
                      value={editForm.prenom}
                      onChange={(e) =>
                        setEditForm({ ...editForm, prenom: e.target.value })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Nom *
                    </label>
                    <input
                      type="text"
                      value={editForm.nom}
                      onChange={(e) =>
                        setEditForm({ ...editForm, nom: e.target.value })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      value={editForm.email}
                      onChange={(e) =>
                        setEditForm({ ...editForm, email: e.target.value })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-gray-50"
                      disabled
                      title="L'email ne peut pas être modifié"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      L'email ne peut pas être modifié
                    </p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Téléphone *
                    </label>
                    <input
                      type="tel"
                      value={editForm.tel}
                      onChange={(e) =>
                        setEditForm({ ...editForm, tel: e.target.value })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    />
                  </div>
                </div>
              </div>

              {/* Formation */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Formation
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Établissement *
                    </label>
                    <input
                      type="text"
                      value={editForm.etablissement}
                      onChange={(e) =>
                        setEditForm({
                          ...editForm,
                          etablissement: e.target.value,
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Diplôme *
                    </label>
                    <input
                      type="text"
                      value={editForm.diplome}
                      onChange={(e) =>
                        setEditForm({ ...editForm, diplome: e.target.value })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Spécialité *
                    </label>
                    <input
                      type="text"
                      value={editForm.specialite}
                      onChange={(e) =>
                        setEditForm({ ...editForm, specialite: e.target.value })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Année *
                    </label>
                    <input
                      type="number"
                      value={editForm.annee}
                      disabled
                      onChange={(e) =>
                        setEditForm({
                          ...editForm,
                          annee: parseInt(e.target.value),
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    />
                  </div>
                </div>
              </div>

              {/* Choix de stages */}
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-4">
                  Choix de stages
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Premier Choix *
                    </label>
                    <select
                      disabled
                      value={editForm.premierChoix}
                      onChange={(e) =>
                        setEditForm({
                          ...editForm,
                          premierChoix: e.target.value,
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    >
                      <option value="">Sélectionnez un stage</option>
                      {internships.map((int) => (
                        <option key={int._id} value={int._id}>
                          {int.title} ({int.type})
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Deuxième Choix *
                    </label>
                    <select
                      disabled
                      value={editForm.deuxiemeChoix}
                      onChange={(e) =>
                        setEditForm({
                          ...editForm,
                          deuxiemeChoix: e.target.value,
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                    >
                      <option value="">Sélectionnez un stage</option>
                      {internships
                        .filter((int) => int._id !== editForm.premierChoix)
                        .map((int) => (
                          <option key={int._id} value={int._id}>
                            {int.title} ({int.type})
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="flex gap-3 pt-4 border-t">
                <button
                  onClick={closeEditModal}
                  className="flex-1 px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
                >
                  Annuler
                </button>
                <button
                  onClick={handleUpdateApplication}
                  disabled={loading}
                  className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  {loading
                    ? "Enregistrement..."
                    : "Enregistrer les modifications"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageApplications;
